import { env } from '../../../config/env'

export class BackedApi {
    private static baseUrl = env.API_URL ?? 'https://api.kinerfy.com/'

    static CreateUser = {
        url: `${this.baseUrl}users`,
        method: 'POST'
    }

    static Login = {
        url: `${this.baseUrl}users/login`,
        method: 'POST'
    }

    static ListDrills = {
        url: `${this.baseUrl}drills`,
        method: 'GET'
    }

    static ListPlans = {
        url: `${this.baseUrl}plans`,
        method: 'GET'
    }

    static CreateAction = {
        url: `${this.baseUrl}actions`,
        method: 'POST'
    }

    static AuthMe = {
        url: `${this.baseUrl}auth/me`,
        method: 'GET'
    }

    static Logout = {
        url: `${this.baseUrl}auth/logout`,
        method: 'POST'
    }


    static CreateWorkout = {
        url: `${this.baseUrl}workouts`,
        method: 'POST'
    }

    static ListActions = (workoutId: string) => ({
        url: `${this.baseUrl}actions/workout/${workoutId}`,
        method: 'GET'
    })

    static ListWorkouts = (drillId: string) => ({
        url: `${this.baseUrl}workouts/drill/${drillId}`,
        method: 'GET'
    })

    static GetWorkout = (id: string) => ({
        url: `${this.baseUrl}workouts/${id}`,
        method: 'GET'
    })

    static DeleteWorkout = (id: string) => ({
        url: `${this.baseUrl}workouts/${id}`,
        method: 'DELETE'
    })

    static CreateSession = {
        url: `${this.baseUrl}sessions`,
        method: 'POST'
    }

    static ListSessions = (workoutId: string) => ({
        url: `${this.baseUrl}sessions/workout/${workoutId}`,
        method: 'GET'
    })

    static ListAllSessions = {
        url: `${this.baseUrl}sessions/`,
        method: 'GET'
    }

    static GetSession = (sessionId: string) => ({
        url: `${this.baseUrl}sessions/${sessionId}`,
        method: 'GET'
    })

    static GetTokenRealTime = (sessionId: string) => ({
        url: `${this.baseUrl}realtime/token?session=${sessionId}`,
        method: 'GET'
    })

    static ActiveAccount = (token: string) => ({
        url: `${this.baseUrl}users/validate?token=${token}`,
        method: 'GET'
    })

}